import { MODE_OF_TRANSPORT_EXPRESS_ROAD } from 'shared/ncts/common/constants'
import { hasText } from 'shared/lib/common-util'
import { PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX, removePrefix } from 'shared/ncts/common/classifier-util'
import { ContactPerson } from '../common/types'
import { RuleResult } from '../../../types/DeclarationP5'

const CustomValidators = {
  validateContactPersonNameAndPhoneRequirement: (
    contactPerson?: ContactPerson | null,
  ): boolean => {
    if (!contactPerson) return false
    return (hasText(contactPerson.name) || hasText(contactPerson.telephone) || hasText(contactPerson.email))
  },
  validateConsignmentConsigneeContactPersonRequirement: ({
    security,
  } : {
    security: string
  }) : RuleResult => {
    if (!['1', '3'].includes(security)) return 'NOT_ALLOWED'

    return 'REQUIRED'
  },
  validateTraderPartyContactPersonPhoneRequirement: (contactPerson: ContactPerson | undefined | null): boolean => {
    if (!contactPerson) return false
    return (hasText(contactPerson.telephone) || hasText(contactPerson.email))
  },
  validateHouseConsignmentContactPersonRequirement: ({
    security,
    specificCircumstanceIndicator,
  }: {
    security: string
    specificCircumstanceIndicator?: string
  }): RuleResult => {
    if (!['1', '3'].includes(security) || specificCircumstanceIndicator !== MODE_OF_TRANSPORT_EXPRESS_ROAD) return 'NOT_ALLOWED'

    return 'REQUIRED'
  },
  validateTransportDocumentReferenceNumberRequirement: (
    country?: string | null,
    documentType?: string | null,
  ) => (
    !!documentType
    && !!country
    && ['N355', 'N337', 'N785'].includes(removePrefix(documentType, PREVIOUS_DOCUMENT_TYPE_CODE_PREFIX) ?? '')
    && ['EE', 'FI'].includes(country)),
}

export default CustomValidators
